import * as Sentry from '@sentry/nextjs';
import NotFound from '../../../components/common/not-found';
import EventDetail from '../../../components/event/detail';
import MiscDetail from '../../../components/misc/detail';
import PackageDetail from '../../../components/package/detail';
import WineDetail from '../../../components/wine/flyerdetail';
import { search } from '../../../lib/api';
import { getProductDetail, guessProductRedirect } from '../../../lib/product';

const components = {
  wein: WineDetail,
  'physischer-event': EventDetail,
  event: EventDetail,
  set: PackageDetail,
};

const Product = (props) => {
  if (!props.product) {
    return <NotFound preview={props.preview} />;
  }

  const Component = components[props.product.productType.slug] || MiscDetail;
  return (
    <div className=''>
      <Component {...props} />
    </div>
  );
};

export default Product;

export async function getStaticProps({ params, preview = false }) {
  const data = await getProductDetail(params.product);

  if (!data.product) {
    const redirect = await guessProductRedirect(params.slug, params.product);
    const productUrl = `/${params.slug}/${params.product}`;

    // Sentry.withScope((scope) => {
    //   scope.setLevel('warning');
    //   scope.setTag('product.url', productUrl);
    //   scope.setTag('product.slug', params.product);
    //   if (redirect) {
    //     scope.setTag('redirect.url', redirect);
    //     scope.setTag('redirect.found', true);
    //   } else {
    //     scope.setTag('redirect.found', false);
    //   }
    //   scope.setExtras({
    //     productSlug: params.product,
    //     productUrl,
    //     redirect,
    //   });
    //   Sentry.captureMessage('Product not found');
    // });

    // if (redirect) {
    //   return {
    //     redirect: {
    //       destination: redirect,
    //       // permanent: true,
    //     },
    //   };
    // }
    return {
      notFound: true,
    };
  }

  return {
    props: { ...data, preview, fallback: false },
  };
}

export async function getStaticPaths() {
  const slugs = (
    await search(
      `filter=handler--product&sort=selling--desc&dt=data_teaser_mini&size=9999`,
    )
  ).results.map((p) => ({
    params: {
      slug: p.parent_slug,
      product: p.slug,
    },
  }));

  return {
    paths: slugs,
    fallback: 'blocking',
  };
}
